import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { QuizProvider } from './context/QuizContext'
import Home from './pages/Home'
import LeadCapture from './pages/LeadCapture'
import Quiz from './pages/Quiz'
import Result from './pages/Result'
import Checkout from './pages/Checkout'
import ThankYou from './pages/ThankYou'
import Admin from './pages/Admin'
import OfferOnly from './pages/OfferOnly'

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <QuizProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/captura" element={<LeadCapture />} />
          <Route path="/teste" element={<Quiz />} />
          <Route path="/resultado" element={<Result />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/obrigado" element={<ThankYou />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/mapa" element={<OfferOnly />} />
        </Routes>
        </QuizProvider>
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default App
